import http from '../utils/request'

/**
 * 角色接口 — 对应后端 RoleController (/api/role)
 */

export const getRoleTree = (keyword) => http.get('/role/tree', { params: { keyword } })
export const getRoleList = () => http.get('/role')
export const getRole = (guid) => http.get(`/role/${guid}`)
export const saveRole = (role) => http.post('/role', role)
export const deleteRole = (guid) => http.delete(`/role/${guid}`)
export const getRoleUsers = (roleGuid) => http.get(`/role/${roleGuid}/users`)
export const addRoleUsers = (roleGuid, users) => http.post(`/role/${roleGuid}/users`, users)
export const removeRoleUser = (roleGuid, account) => http.delete(`/role/${roleGuid}/users/${encodeURIComponent(account)}`)
